import { render, staticRenderFns } from "./DetailSignBatch.vue?vue&type=template&id=caa40424"
import script from "./DetailSignBatch.vue?vue&type=script&lang=js"
export * from "./DetailSignBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports